
import { z } from 'zod';
import { groupSchema } from './group/group.schema';
import { companySchema } from './company/company.schema';
import { branchSchema } from './branch/branch.schema';

export const vehiculeCheckClientSchema = z.object({
  roleType: z.string().nullish(),
  firstname: z.string().nullish(),
  lastname: z.string().nullish(),
  email: z.string().nullish(),
  phone: z.string().nullish(),
  addressLine1: z.string().nullish(),
  addressLine2: z.string().nullish(),
  postalCode: z.string().nullish(),
  city: z.string().nullish(),
  country: z.string().nullish(),
  groups: z.array(groupSchema).nullish(),
  companies: z.array(companySchema).nullish(),
  branches: z.array(branchSchema).nullish(),
});

export type TVehiculeCheckClientSchema = z.infer<typeof vehiculeCheckClientSchema>;
